import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import { EmailAddress, ForgotPassword, Password, RememberPassword, SignIn } from "../Constant";

import { useNavigate, Link } from "react-router-dom";
import man from "../assets/images/dashboard/profile.png";

import CustomizerContext from "../_helper/Customizer";
import { useAuth } from '../_helper/Auth/AuthProvider'
import OtherWay from './OtherWay'
import { ToastContainer, toast } from 'react-toastify'

const Signin = ({ selected }) => {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [togglePassword, setTogglePassword] = useState(false)
	const history = useNavigate()
	const { layoutURL } = useContext(CustomizerContext)
	const { login } = useAuth()

	const [value, setValue] = useState(localStorage.getItem('profileURL' || man))
	const [name, setName] = useState(localStorage.getItem('Name'))

	useEffect(() => {
		localStorage.setItem('profileURL', man)
		localStorage.setItem('Name', 'Emay Walter')
	}, [value, name])

	const loginAuth = async (e) => {
		e.preventDefault()
		setValue(man)
		setName('Emay Walter')

		const result = await login(email, password)
		if (result.success) {
			// Redirect based on user role
			const userRole = result.user?.role
			let redirectPath

			switch (userRole) {
				case 'Instructor':
					redirectPath = `${process.env.PUBLIC_URL}/instructor/class-management/${layoutURL}`
					break
				case 'Admin':
					redirectPath = `${process.env.PUBLIC_URL}/admin/students/${layoutURL}`
					break
				case 'Student911':
					redirectPath = `${process.env.PUBLIC_URL}/student911/agenda/${layoutURL}`
					break
				case 'Student12':
					redirectPath = `${process.env.PUBLIC_URL}/student12/agenda/${layoutURL}`
					break
				case 'Parent':
					redirectPath = `${process.env.PUBLIC_URL}/parent/profile/${layoutURL}`
					break
				default:
					redirectPath = `${process.env.PUBLIC_URL}/${userRole}/profile/${layoutURL}`
			}

			history(redirectPath)
			toast.success('Successfully logged in!')
		} else {
			toast.error(result.error || 'Invalid credentials!')
		}
	}

	return (
		<Fragment>
			<Container fluid={true} className="p-0 login-page">
				<Row>
					<Col xs="12">
						<div className="login-card">
							<div className="login-main login-tab">
								<Form className="theme-form">
									<H4>{selected === 'simpleLogin' ? '' : 'Sign In With Simple Login'}</H4>
									<P>{'Enter your email & password to login'}</P>
									<FormGroup>
										<Label className="col-form-label">{EmailAddress}</Label>
										<Input className="form-control" type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
									</FormGroup>
									<FormGroup className="position-relative">
										<Label className="col-form-label">{Password}</Label>
										<div className="position-relative">
											<Input
												className="form-control"
												type={togglePassword ? 'text' : 'password'}
												onChange={(e) => setPassword(e.target.value)}
												value={password}
											/>
											<div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
												<span className={togglePassword ? '' : 'show'}></span>
											</div>
										</div>
									</FormGroup>
									<div className="position-relative form-group mb-0">
										<div className="checkbox">
											<Input id="checkbox1" type="checkbox" />
											<Label className="text-muted" for="checkbox1">
												{RememberPassword}
											</Label>
										</div>
										<Link className="link" to={`${process.env.PUBLIC_URL}/forgot-password`}>
											{ForgotPassword}
										</Link>
										<Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginAuth(e) }}>{SignIn}</Btn>
									</div>
									<OtherWay />
								</Form>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
			<ToastContainer />
		</Fragment>
	)
}

export default Signin;
